
// 本地文件转为base64
export const getBase64 = (file: Blob): Promise<string> => {
    return new Promise(function (resolve, reject) {
        const reader = new FileReader()
        let imgResult = ''
        reader.readAsDataURL(file)
        reader.onload = function () {
            imgResult = reader.result as string
        }
        reader.onerror = function (error) {
            reject(error)
        }
        reader.onloadend = function () {
            resolve(imgResult)
        }
    })
}
// 判断文件src是否包含域名
export const fileTruePath = (path: string): string => {
    if (path.indexOf("http") == 0) {
        return path
    } else {
        return `${process.env.VUE_APP_BASE}${path}`
    }
}

// 时间戳转时间
export const strToTime = (t: number, showSeconde: boolean = true): string => {
    if (!t) {
        return ""
    }
    let date = new Date(t);
    console.log(date, t)
    let Y = date.getFullYear();
    let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
    let D = date.getDate();
    let h = date.getHours();
    let m = date.getMinutes();
    let s = date.getSeconds();
    return showSeconde ? `${Y}-${M}-${D < 10 ? '0' + D : D} ${h < 10 ? '0' + h : h}:${m < 10 ? '0' + m : m}:${s < 10 ? '0' + s : s}` : `${Y}-${M}-${D}`
}
export const getDate = (t: string | Date = '', showSeconde: boolean = true): string => {
    let date: Date = new Date()
    if (t && t == '') {
        date = new Date(t);
    }
    let Y = date.getFullYear();
    let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
    let D = date.getDate();
    let h = date.getHours();
    let m = date.getMinutes();
    let s = date.getSeconds();
    return showSeconde ? `${Y}-${M}-${D} ${h}:${m}:${s}` : `${Y}-${M}-${D}`
}
export const pwdVali = (str: string): { code: number, msg: string } => {
    const reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\W_]).{8,16}$/
    if (reg.test(str)) {
        return { code: 1, msg: "" }
    }
    return { code: 0, msg: "密码包含大小写字母,数字,特殊字符且长度在8到16位之间" }
}
// 校验身份证
export const valiIdCard = (idCard?: string) => {
    if (!idCard) {
        return false;
    }
    // areaCode:地区码  checkCode：最后一位的校验码
    const areaCode = [11, 12, 13, 14, 15, 21, 22, 23, 31, 32, 33, 34, 35, 36, 37, 41, 42, 43, 44, 45, 46, 50, 51, 52, 53, 54, 61, 62, 63, 64, 65, 71, 81, 82, 91];
    const checkCode = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];

    if (idCard.length === 15) {               // 如果是15位的身份证号码

        // 判断地区码
        const idCardAreaCode = parseInt(idCard.substr(0, 2));
        if (areaCode.indexOf(idCardAreaCode) === -1) {
            return false;
        }

        // 判断时间
        const borthYear = parseInt(idCard.substr(6, 2)) + 1900;
        const isRunNian = (borthYear % 400 === 0) || (borthYear % 100 !== 0 && borthYear % 4 === 0);
        let regStr = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}$/;
        if (isRunNian) {
            regStr = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}$/;
        }
        if (!idCard.match(regStr)) {
            return false;
        }

        return true;
    } else if (idCard.length === 18) {        // 如果是18位的身份证号码

        // 判断地区码
        const idCardAreaCode = parseInt(idCard.substr(0, 2));
        if (areaCode.indexOf(idCardAreaCode) === -1) {
            return false;
        }

        // 判断时间
        const borthYear = parseInt(idCard.substr(6, 4));
        const isRunNian = (borthYear % 400 === 0) || (borthYear % 100 !== 0 && borthYear % 4 === 0);
        let regStr = /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}[0-9Xx]$/;
        if (isRunNian) {
            regStr = /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}[0-9Xx]$/;
        }
        if (!idCard.match(regStr)) {
            return false;
        }

        // 判断最后一位---校验码
        const sumIdCard = (parseInt(idCard.substr(0, 1)) + parseInt(idCard.substr(10, 1))) * 7 +
            (parseInt(idCard.substr(1, 1)) + parseInt(idCard.substr(11, 1))) * 9 +
            (parseInt(idCard.substr(2, 1)) + parseInt(idCard.substr(12, 1))) * 10 +
            (parseInt(idCard.substr(3, 1)) + parseInt(idCard.substr(13, 1))) * 5 +
            (parseInt(idCard.substr(4, 1)) + parseInt(idCard.substr(14, 1))) * 8 +
            (parseInt(idCard.substr(5, 1)) + parseInt(idCard.substr(15, 1))) * 4 +
            (parseInt(idCard.substr(6, 1)) + parseInt(idCard.substr(16, 1))) * 2 +
            parseInt(idCard.substr(7, 1)) * 1 + parseInt(idCard.substr(8, 1)) * 6 +
            parseInt(idCard.substr(9, 1)) * 3;
        const modNum = checkCode[sumIdCard % 11];
        if (modNum !== idCard.substr(17, 1).toUpperCase()) {
            return false;
        }

        return true
    } else {
        return false;
    }
}
export const valiPhone = (phone: string) => {
    if (!phone || (phone.length != 11 && phone.length != 12)) {
        return false;
    }
    //通过正则表达式判断手机号码格式是否正确,根据电信，联通、移动手机号码规则可以到以下正则
    // 手机号码第一位是[1]开头，第二位[3,4,5,7,8]中的一位，第三位到第十一位则是[0-9]中的数字；
    //^1表示开头为1
    //[3|4|5|7|8] 表示3、4、5、7、8中的一位数值
    //[0-9]{9} 匹配包含0-9的数字
    let reg = /^1[3|4|5|6|7|8|9][0-9]{9}/, tel = /^0\d{2,3}-\d{7,8}/;
    if (reg.test(phone) || tel.test(phone)) {
        return true;//手机号码正确
    }

    return false;
}
// 根据返回校验位设置表格背景色
const valiDataChange = (row: any): string => {
    if (row.row && row.row.checkDigitTag) {
        return "tab_col_err"
    }
    return ""
}
/**
 * 根据身份证获取出生日期（yyyy-MM-dd）
 * @param psidno
 * @returns {birthday:yyyy-MM-dd}
 * @constructor
 */
export const GetBirthday = (psidno: string) => {
    let birthdayno, birthdaytemp
    if (psidno.length == 18) {
        birthdayno = psidno.substring(6, 14)
    } else if (psidno.length == 15) {
        birthdaytemp = psidno.substring(6, 12)
        birthdayno = "19" + birthdaytemp
    } else {
        return "";
    }
    let birthday = birthdayno.substring(0, 4) + "-" + birthdayno.substring(4, 6) + "-" + birthdayno.substring(6, 8)
    return birthday
}

/**
 *根据输入的身份证获取性别代码
 * @param psidno
 * @returns {sex}
 * @constructor
 */
export const Getsex = (psidno: string): number => {
    let sexno: number, sex: number
    if (psidno.length == 18) {
        sexno = Number(psidno.substring(16, 17))
    } else if (psidno.length == 15) {
        sexno = Number(psidno.substring(14, 15))
    } else {
        return 0;
    }
    let tempid = sexno % 2;
    if (tempid == 0) {
        sex = 2
    } else {
        sex = 1
    }
    return sex
}

//下载 content为base64
export const downloadFile = (fileName: string, content: string) => {
    let aLink = document.createElement('a');
    let blob = base64ToBlob(content); //new Blob([content]);

    let evt = document.createEvent("HTMLEvents");
    evt.initEvent("click", true, true);//initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
    aLink.download = fileName;
    aLink.href = URL.createObjectURL(blob);
    // aLink.dispatchEvent(evt);
    aLink.click()
}
//base64转blob
export const base64ToBlob = (code: string) => {
    let parts = code.split(';base64,');
    let contentType = (parts[0]||"").split(':')[1];
    let raw = window.atob(parts[1]);
    let rawLength = raw.length;

    let uInt8Array = new Uint8Array(rawLength);

    for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
    }
    return new Blob([uInt8Array], { type: contentType });
}

const func = {
    getBase64,
    fileTruePath,
    valiDataChange,
    strToTime
}
export default func